import { Inject, Injectable } from '@angular/core';
import { EntityService } from "@shared/services/entity.service";
import { EntityFeatureNameEnum } from "@shared/contracts/entity-store.contract";
import { UserType } from "@generated/graphql";
import { User } from "@modules/user/models/user.model";
import { EXPERT_STORE, ExpertStore } from "@modules/user/store/expert/expert.store";
import { UserFactory, userFactory } from "@modules/user/factories/user.factory";
import { map, Observable } from "rxjs";
import { Country } from "@modules/country/models/country.model";
import { ExpertApi } from "@modules/user/api/expert.api";
import { ACTIVE_USER } from "@modules/auth/providers/auth.provider";
import {Store} from "@ngrx/store";

@Injectable({
  providedIn: 'root'
})
export class ExpertService extends EntityService<EntityFeatureNameEnum.Expert, UserType, User> {
  constructor (
    protected readonly store: Store,
    @Inject(EXPERT_STORE) protected readonly entityStore: ExpertStore,
    private readonly expertApi: ExpertApi,
    @Inject(ACTIVE_USER) private readonly activeUser$: Observable<User>
  ) {
    super(store, entityStore)
  }

  get factory (): UserFactory {
    return userFactory;
  }

  getByCountryOfResponsibility$ (id: Country['id']): Observable<User[]> {
    return this.store.select(
      this.entityStore.selectByCountryOfResponsibility(id)
    ).pipe(
      map(users => users ? users.map(user => userFactory.create(user)) : [])
    )
  }
}
